import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InformationModesFetchFailedAction = {
	type: 'INFORMATION_MODES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InformationModesFetchFailedAction => ({
	type: 'INFORMATION_MODES_FETCH_FAILED',
	payload,
});
